import React from 'react'
import SubmitIssuedCheckProvider from './index.provider'
import SubmitIssuedCheckContent from './index.content'

const SubmitIssuedCheckScreen: React.FC = () => {
  return (
    <SubmitIssuedCheckProvider>
      <SubmitIssuedCheckContent />
    </SubmitIssuedCheckProvider>
  )
}

export default SubmitIssuedCheckScreen
